import { For, JSX, Show, children, createMemo } from 'solid-js';

export enum Anchor {
  TopLeft = 'TopLeft',
  TopCenter = 'TopCenter',
  TopRight = 'TopRight',
  BottomLeft = 'BottomLeft',
  BottomCenter = 'BottomCenter',
  BottomRight = 'BottomRight',
  Left = 'Left',
  Right = 'Right',
}

const AnchorStyles: { [key in Anchor]: string } = {
  [Anchor.TopLeft]: 'top-5 left-5 items-start justify-start',
  [Anchor.TopCenter]:
    'top-5 left-1/2 transform -translate-x-1/2 items-start justify-center',
  [Anchor.TopRight]: 'top-5 right-5 items-start justify-end',
  [Anchor.BottomLeft]: 'bottom-5 left-5 items-end justify-start',
  [Anchor.BottomCenter]:
    'bottom-5 left-1/2 transform -translate-x-1/2 items-end justify-center',
  [Anchor.BottomRight]: 'bottom-5 right-5 items-end justify-end',
  [Anchor.Left]:
    'top-1/2 left-5 flex-col items-start justify-center transform -translate-y-1/2',
  [Anchor.Right]:
    'top-1/2 right-5 flex-col items-end justify-center transform -translate-y-1/2',
};

export interface ToolbarPositionerProps {
  children: JSX.Element | JSX.Element[];
  anchor?: Anchor;
  customClasses?: string;
  autoHide?: boolean;
}

export const groupHoverReveal =
  'opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out';

export const ToolbarPositioner = (
  props: ToolbarPositionerProps
): JSX.Element => {
  const anchorClasses = (): string =>
    props.anchor !== undefined ? AnchorStyles[props.anchor] : '';

  const validChildren = createMemo(() => {
    return children(() => props.children)
      .toArray()
      .filter((child) => child != null);
  });

  return (
    <Show when={validChildren().length > 0}>
      <div
        class={`flex absolute z-toolbar hover:z-dropdown focus-within:z-dropdown ${anchorClasses()} ${props.autoHide ? groupHoverReveal : ''} ${props.customClasses ?? ''}`}
      >
        <For each={validChildren()}>{(child) => <>{child}</>}</For>
      </div>
    </Show>
  );
};
